import React, { ReactElement } from 'react';
import { ResponsiveContainer } from 'recharts';
import styles from './ChartContainer.module.css';

interface ChartContainerProps {
  children: ReactElement;
  height?: number;
}

const ChartContainer: React.FC<ChartContainerProps> = ({ children, height = 200 }) => (
  <div className={styles.chartContainer}>
    <ResponsiveContainer width="100%" height={height}>
      {children}
    </ResponsiveContainer>
    <div className={styles.overlay} />
  </div>
);

export default ChartContainer;
